import { Grid, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { FormAutocomplete, FormTextField} from "../../../common/form-fields-wrappers";
import {IRaDetailView} from "../../../models/models";

const BillingOwnerInfoCompany = ({boType}: {boType: 'first' | 'second'}) => {
    const {t} = useTranslation(['network', 'translation']);
    const raDetailForm = useFormContext<IRaDetailView>();
    const theme = useTheme();
    const { watch } = useFormContext<IRaDetailView>();
    const siren = watch(`billingOwnerInfo.${boType}.siren`);
    const siret = watch(`billingOwnerInfo.${boType}.siret`);
    const vatNumberCountry = watch(`billingOwnerInfo.${boType}.vatNumberCountry`);
    const billingCountry_code = watch(`billingOwnerInfo.${boType}.billingCountry.code`);

    //console.log('billingOwnerInfo vatNumberCountry: ' + vatNumberCountry);
    //console.log('billingOwnerInfo billingCountry_code: ' + billingCountry_code);


    const checkSirenVisibility = () =>{
        let visibility = !!vatNumberCountry ? vatNumberCountry === "FR" : billingCountry_code === "FR";
        return visibility;
    }



    return (
        <Grid container columnSpacing={2} sx={{mb: theme.spacing(4)}}>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.legalEntity`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.company.legalEntity")}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.companyName`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.company.companyName")}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.vatNumberCountry`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.company.vatNumberCountry")}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.vatNumber`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.company.vatNumber")}
                    fullWidth
                    disabled
                />
            </Grid>
            {//siren && //TODO siren --> check Visibilita'
            checkSirenVisibility() &&
            (<Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.siren`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.company.siren")}
                    fullWidth
                    disabled
                />
            </Grid>)}
             {//siret && //TODO siret --> check Visibilita'
             checkSirenVisibility() &&
                (<Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.siret`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.company.siret")}
                    fullWidth
                    disabled
                />
            </Grid>)}
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.fiscalCode`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.company.fiscalCode")}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.firstEmail`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.company.firstEmail")}
                    fullWidth
                    disabled
                />
            </Grid>
            {!checkSirenVisibility() &&
                (<Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                    <FormTextField<IRaDetailView>
                        name={`billingOwnerInfo.${boType}.certifiedEmail`}
                        control={raDetailForm.control}
                        label={t("raDetail.masks.company.certifiedEmail")}
                        fullWidth
                        disabled
                    />
                </Grid>)
            }
            {!checkSirenVisibility() &&
                (<Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                    <FormTextField<IRaDetailView>
                        name={`billingOwnerInfo.${boType}.SDI`}
                        control={raDetailForm.control}
                        label={t("raDetail.masks.company.SDI")}
                        fullWidth
                        disabled
                    />
                </Grid>)
            }
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormAutocomplete<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.billingCountry`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.company.billingCountry")}
                    fullWidth
                    disabled
                    options={[]}
                    getOptionLabel={(opt) => opt?.description}
                    isOptionEqualToValue={(_option, value) => value?.description}
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormAutocomplete<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.billingProvince`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.company.billingProvince")}
                    fullWidth
                    disabled
                    options={[]}
                    getOptionLabel={(opt) => opt?.description}
                    isOptionEqualToValue={(_option, value) => value?.description}
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormAutocomplete<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.billingCity`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.company.billingCity")}
                    fullWidth
                    disabled
                    options={[]}
                    getOptionLabel={(opt) => opt?.description}
                    isOptionEqualToValue={(_option, value) => value?.description}
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.billingAddress`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.company.billingStreetName")}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.billingStreetNumber`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.company.billingStreetNumber")}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                <FormTextField<IRaDetailView>
                    name={`billingOwnerInfo.${boType}.billingPostalCode`}
                    control={raDetailForm.control}
                    label={t("raDetail.masks.company.billingPostalCode")}
                    fullWidth
                    disabled
                />
            </Grid>
        </Grid>
    )
};

export default BillingOwnerInfoCompany;